"use client";

import { Link } from "@/i18n/routing";
import { IconForwardArrowBlack, IconSelectField, IconSelectedAccountMenu } from "@repo/assets/images";
import { LogOutButton } from "@repo/components";
import { ACCOUNT_MENU } from "@repo/constants/account";
import { CMS_LINKS, FAVOURITE_LINK } from "@repo/constants/common";
import { useActivePath } from "@repo/lib/hooks/common";
import { useTrackAccountMenuClick } from "@repo/lib/hooks/webengage";
import { BottomSheet } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";
const MenuItem = ({
  item,
  isActive,
  isMobileMenu,
  onClick,
  t
}) => {
  const IconComponent = item.icon;
  return isMobileMenu ? <div className={cx("border-supportiveDarkGray flex h-9 cursor-pointer items-center justify-center border", {
    "bg-icon-bg text-supportiveBlack": isActive,
    "text-supportiveMediumGray": !isActive,
    hidden: isMobileMenu && !isActive
  })} onClick={() => onClick(!isActive ? item.name : "")} data-sentry-component="MenuItem" data-sentry-source-file="AccountMenuMobile.jsx">
      <IconComponent className={cx("me-2 fill-current", {
      "text-supportiveBlack": isActive
    })} data-sentry-element="IconComponent" data-sentry-source-file="AccountMenuMobile.jsx" />
      <span className="text-sm font-medium">{t(item.label)}</span>
      <IconSelectField className="text-icon-color mx-2 size-4 fill-current" data-sentry-element="IconSelectField" data-sentry-source-file="AccountMenuMobile.jsx" />
    </div> : <Link href={item.url} onClick={() => onClick(!isActive ? item.name : "")} className="border-lightgray hover:bg-icon-bg hover:text-supportiveBlack flex items-center whitespace-nowrap border-b px-4 py-2" data-sentry-element="Link" data-sentry-component="MenuItem" data-sentry-source-file="AccountMenuMobile.jsx">
      <IconComponent className={cx("me-2 fill-current", {
      "text-icon-color": isActive
    })} data-sentry-element="IconComponent" data-sentry-source-file="AccountMenuMobile.jsx" />
      <span>{t(item.label)}</span>
      {isActive ? <IconSelectedAccountMenu className="text-icon-color ms-auto fill-current" /> : <IconForwardArrowBlack className="text-icon-color ms-auto fill-current rtl:rotate-180" />}
    </Link>;
};
const Menu = ({
  activePath,
  isMobileMenu,
  onClick,
  t,
  session
}) => {
  // Utility function to render menu sections
  const renderMenuSection = menuSection => menuSection?.map(item => {
    const isOrdersRoute = activePath.startsWith("account/orders/") && item.url === "/account/orders";
    const isActive = isOrdersRoute || activePath === item.url;
    return <MenuItem key={item.id} item={item} isActive={isActive} isMobileMenu={isMobileMenu} onClick={onClick} t={t} />;
  });
  return <div className={cx("", {
    "border-supportiveDarkGray -mx-4 mt-3 border-t": !isMobileMenu
  })} data-sentry-component="Menu" data-sentry-source-file="AccountMenuMobile.jsx">
      {!session && renderMenuSection(FAVOURITE_LINK)}
      {session && renderMenuSection(ACCOUNT_MENU.DasboardLinks)}
      {session && renderMenuSection(ACCOUNT_MENU.AccountSettings)}
      {session && renderMenuSection(ACCOUNT_MENU.Products)}
      {renderMenuSection(CMS_LINKS)}
      {session && <LogOutButton />}
    </div>;
};
const AccountMenuMobile = ({
  session
}) => {
  const t = useTranslations("Common");
  const [isUserDropdownBottomSheetOpen, setIsUserDropdownBottomSheetOpen] = useState(false);
  const {
    trackAccountMenuClickEvent
  } = useTrackAccountMenuClick();
  const activePath = useActivePath();
  const toggleBottomSheet = useCallback(() => {
    setIsUserDropdownBottomSheetOpen(!isUserDropdownBottomSheetOpen);
  }, [isUserDropdownBottomSheetOpen]);
  const handleMenuItemClick = useCallback(menuTitle => {
    toggleBottomSheet();
    trackAccountMenuClickEvent(menuTitle);
  }, [toggleBottomSheet, trackAccountMenuClickEvent]);
  return <>
      <div className="md:hidden" onClick={toggleBottomSheet}>
        <Menu activePath={activePath} isMobileMenu={true} onClick={handleMenuItemClick} t={t} session={session} data-sentry-element="Menu" data-sentry-source-file="AccountMenuMobile.jsx" />
      </div>
      <BottomSheet isOpen={isUserDropdownBottomSheetOpen} onClose={toggleBottomSheet} title={t("Menu")} variant="auto" data-sentry-element="BottomSheet" data-sentry-source-file="AccountMenuMobile.jsx">
        <Menu activePath={activePath} onClick={handleMenuItemClick} t={t} session={session} data-sentry-element="Menu" data-sentry-source-file="AccountMenuMobile.jsx" />
      </BottomSheet>
    </>;
};
export default AccountMenuMobile;